// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Sun } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconSun(props: any) {
    return <IconBase icon={Sun} {...props} />
  }

  export default IconSun
  